import {PopupTimeDelayTriggerRestDto} from "@/api/pharma-cms-popup/models";

export class PopupTimeDelayTriggerRestDtoModel implements PopupTimeDelayTriggerRestDto {
    time_in_seconds: number;

    constructor(time_in_seconds: number) {
        this.time_in_seconds = time_in_seconds;
    }

    public static createWithDefaults(): PopupTimeDelayTriggerRestDtoModel {
        return new this(0);
    }
}
